import { model as i18n } from '!/i18n'
import { combine } from 'effector'

export const $libraryTranslations = combine(i18n.$t, ({ t }) => ({
  libraryTitle: t('my_list'),
  liveChannels: t('live_channels'),
  movies: t('movies'),
  shows: t('series'),
  events: t('event_other'),
}))
